import { t } from "@lingui/macro";
import { useNotifications } from "./useNotifications";
import { Box, Container } from "@mui/material";
import {
  MenuList,
  MenuListItemType,
  MenuListItemVariant,
  WfIconNavigationCloseRegular,
} from "@WahooFitness/redesignr";
import React, { useCallback, useMemo } from "react";
import { ReactRouterLinkWrapper } from "@/components/MenuList/ReactRouterLinkWrapper";
import { WarningAlt } from "@carbon/icons-react";
import { ActionableAlert } from "../ActionableAlert";
import { ErrorBoundary, GlobalHeader, postClose } from "@WahooFitness/wahoo-offline-mfe";

const Notifications: React.FC<{ closeOnBack: boolean }> = ({ closeOnBack }) => {
  const {
    notificationTypes,
    notificationSettingsLoading,
    notificationSettingsError,
    notificationsEnabled,
    requestNotificationPermission,
  } = useNotifications();

  const categorySections = useMemo((): MenuListItemType[] => {
    return notificationTypes.map(
      (notificationType): MenuListItemType => ({
        id: `category ${notificationType.id}`,
        content: notificationType.name,
        secondaryContent: notificationType.description,
        variant: MenuListItemVariant.InternalLink,
        linkLocation: `/notifications/${notificationType.id}`,
        linkComponent: ReactRouterLinkWrapper,
      })
    );
  }, [notificationTypes]);

  const closeAction = useCallback(() => {
    postClose("notifications");
  }, []);

  return (
    <>
      <GlobalHeader
        title={t`Notifications`}
        primaryLeftActionItem={
          closeOnBack
            ? {
                icon: <WfIconNavigationCloseRegular />,
                action: closeAction,
              }
            : undefined
        }
      />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box p={2} display="flex" flexDirection="column" gap={2}>
          <ErrorBoundary isLoading={notificationSettingsLoading} error={notificationSettingsError}>
            {!notificationsEnabled && (
              <ActionableAlert
                title={t`Please enable notifications`}
                message={t`Enable notifications to get ride uploads, workout reminders, training tips, and important firmware updates for your devices.`}
                icon={<WarningAlt size={24} />}
                confirmText={t`Enable`}
                onConfirm={requestNotificationPermission}
              />
            )}
            <MenuList sx={{ padding: 0 }} disableGutters listItems={categorySections} />
          </ErrorBoundary>
        </Box>
      </Container>
    </>
  );
};

export { Notifications };
